import { createApiCall } from 'lib/base';

const FETCH_STOCK_EVENT_CREATE_API_ID = 'DASHBOARD/FETCH_STOCK_EVENT_CREATE_API';

const apiCall = createApiCall(FETCH_STOCK_EVENT_CREATE_API_ID, ({ payload }) => ({
  endpoint: `/api/admin/stock-events`,
  method: 'POST',
  body: payload,
  notify: true,
}));

export default apiCall;
